import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Admin.css";
import { Avatar } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { AppDispatch, useAppSelector } from "../App/store";
import {
  clearClientStatescreen,
  selectActiveScreen,
  setActiveScreen,
} from "../../Features/Screens/Screens";
import { clearClientState } from "../../Features/AllClients/AllClients";
import { clearClientStateuser } from "../../Features/ManageUsers/ManageUsersSlice";
import { clearClientStateDoc } from "../../Features/Documents/Documents";

const AdminSideBar = () => {
  const dispatch = useDispatch<AppDispatch>();
  const panel = useAppSelector(selectActiveScreen);
  const navigate = useNavigate();
  const [openLogout, setOpenLogout] = useState<boolean>(false);

  const arrayNavbar = [
    {
      access: ["AD", "AR", "CO"],
      component: (
        <NavLink
          to="Dashboard"
          onClick={() => {
            dispatch(setActiveScreen("Dashboard"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "Dashboard" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              viewBox="0 0 16 16"
            >
              <path
                fill="#7D7D7D"
                fillRule="evenodd"
                d="M8.245.657a.618.618 0 01.44-.156c3.428.102 6.293 2.59 6.813 5.917.003.02.003.04 0 .06a.586.586 0 01-.148.431.609.609 0 01-.416.202l-5.76.38a.687.687 0 01-.52-.173.66.66 0 01-.22-.494l-.387-5.657v-.093a.595.595 0 01.198-.417zM7.85 8.971l4.972-.307h.054c.214.004.418.09.567.242.15.151.231.354.228.565-.197 2.866-2.299 5.261-5.159 5.879-2.86.617-5.792-.693-7.196-3.214a6.161 6.161 0 01-.768-2.352 4.467 4.467 0 01-.047-.74C.51 5.996 2.68 3.365 5.717 2.72a.826.826 0 01.897.447c.079.12.1.266.109.409.052.805.106 1.604.16 2.4l.138 2.049c-.002.16.023.32.075.473.122.3.425.49.754.473z"
                clipRule="evenodd"
              ></path>
            </svg>
          </div>
          <div>
            <span>Dashboard</span>
          </div>
        </NavLink>
      ),
    },
    {
      access: ["AD", "AR", "CO"],
      component: (
        <NavLink
          to="AllClients"
          onClick={() => {
            dispatch(setActiveScreen("AllClients"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "AllClients" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.1187 3.17464C12.1187 4.9369 10.7139 6.34995 8.96178 6.34995C7.2097 6.34995 5.80481 4.9369 5.80481 3.17464C5.80481 1.4117 7.2097 0 8.96178 0C10.7139 0 12.1187 1.4117 12.1187 3.17464ZM8.96181 11.9996C6.38842 11.9996 4.1911 11.5916 4.1911 9.95971C4.1911 8.32713 6.37432 7.9043 8.96181 7.9043C11.5352 7.9043 13.7325 8.31227 13.7325 9.94485C13.7325 11.5767 11.5493 11.9996 8.96181 11.9996ZM13.4678 3.23277C13.4678 4.13112 13.1998 4.96801 12.7297 5.66373C12.6814 5.73533 12.7244 5.83192 12.8097 5.84678C12.9272 5.86704 13.0487 5.87853 13.1723 5.8819C14.4046 5.91433 15.5106 5.11661 15.8162 3.91565C16.2688 2.13178 14.9398 0.530273 13.2475 0.530273C13.0635 0.530273 12.8876 0.549862 12.7163 0.584985C12.6928 0.590389 12.668 0.601196 12.6545 0.622135C12.6384 0.647803 12.6505 0.682251 12.6666 0.704541C13.175 1.4212 13.4678 2.29524 13.4678 3.23277ZM15.5086 7.13436C16.3366 7.29714 16.8812 7.62947 17.1069 8.11242C17.2976 8.50891 17.2976 8.9689 17.1069 9.36471C16.7617 10.1138 15.6489 10.3543 15.2165 10.4164C15.1271 10.4299 15.0553 10.3522 15.0647 10.2624C15.2856 8.18672 13.5282 7.20258 13.0735 6.9763C13.0541 6.96617 13.05 6.95064 13.052 6.94118C13.0534 6.93443 13.0614 6.92362 13.0762 6.92159C14.06 6.90335 15.1177 7.03845 15.5086 7.13436ZM4.82789 5.8819C4.95146 5.87853 5.07234 5.86772 5.19053 5.84678C5.27582 5.83192 5.3188 5.73533 5.27045 5.66373C4.80036 4.96801 4.53241 4.13112 4.53241 3.23277C4.53241 2.29524 4.82521 1.4212 5.33357 0.704541C5.34969 0.682251 5.3611 0.647803 5.34566 0.622135C5.33223 0.601872 5.30671 0.590389 5.28388 0.584985C5.11196 0.549862 4.93601 0.530273 4.75201 0.530273C3.0597 0.530273 1.73069 2.13178 2.18399 3.91565C2.48955 5.11661 3.59559 5.91433 4.82789 5.8819ZM4.9477 6.9405C4.94972 6.95064 4.94569 6.9655 4.92689 6.9763C4.47157 7.20258 2.71412 8.18672 2.93506 10.2617C2.94446 10.3522 2.87328 10.4292 2.78396 10.4164C2.35148 10.3543 1.23872 10.1138 0.893544 9.36471C0.702152 8.96822 0.702152 8.50891 0.893544 8.11242C1.11919 7.62947 1.66314 7.29714 2.49117 7.13368C2.88268 7.03845 3.9397 6.90335 4.9242 6.92159C4.93897 6.92362 4.94636 6.93443 4.9477 6.9405Z"
                fill="#7D7D7D"
              />
            </svg>
          </div>
          <div>
            <span>All Clients</span>
          </div>
        </NavLink>
      ),
    },
    {
      access: ["AD", "AR", "CO"],
      component: (
        <NavLink
          to="MeetingCalender"
          onClick={() => {
            dispatch(setActiveScreen("Meeting Calender"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "Meeting Calender" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="17"
              viewBox="0 0 15 17"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9919 1.1915L10.9927 1.78495C13.1735 1.95586 14.614 3.44187 14.6164 5.72073L14.625 12.3911C14.6281 14.8757 13.0672 16.4045 10.5652 16.4084L4.45357 16.4163C1.96719 16.4195 0.38673 14.8544 0.383603 12.3627L0.375005 5.77058C0.371879 3.47669 1.76162 1.99464 3.94239 1.79444L3.9416 1.20099C3.94082 0.852833 4.19876 0.590922 4.54268 0.590922C4.8866 0.590131 5.14454 0.85125 5.14532 1.19941L5.1461 1.7533L9.78901 1.74697L9.78823 1.19308C9.78745 0.84492 10.0454 0.583801 10.3893 0.58301C10.7254 0.582218 10.9912 0.843338 10.9919 1.1915ZM1.5795 6.01508L13.4135 5.99925V5.72231C13.3798 4.02108 12.5263 3.12853 10.9943 2.99559L10.9951 3.60487C10.9951 3.94512 10.7301 4.21494 10.394 4.21494C10.0501 4.21573 9.79136 3.9467 9.79136 3.60645L9.79057 2.96552L5.14767 2.97185L5.14845 3.61199C5.14845 3.95303 4.89129 4.22206 4.54737 4.22206C4.20345 4.22285 3.94473 3.95461 3.94473 3.61357L3.94395 3.0043C2.41976 3.15701 1.57638 4.05273 1.57872 5.76899L1.5795 6.01508ZM10.0649 9.6114V9.62011C10.0727 9.98409 10.3698 10.2602 10.7301 10.2523C11.0818 10.2436 11.3624 9.94216 11.3546 9.57817C11.3382 9.23001 11.056 8.94595 10.7051 8.94674C10.3455 8.95465 10.0641 9.24742 10.0649 9.6114ZM10.7106 13.1642C10.351 13.1563 10.061 12.8564 10.0602 12.4924C10.0524 12.1284 10.3408 11.827 10.7004 11.8183H10.7082C11.0756 11.8183 11.3734 12.1181 11.3734 12.49C11.3742 12.8619 11.0771 13.1634 10.7106 13.1642ZM6.84459 9.62406C6.86023 9.98805 7.15803 10.2721 7.51758 10.2563C7.86932 10.2397 8.14992 9.93899 8.13429 9.57501C8.12569 9.21893 7.83649 8.94199 7.48475 8.94278C7.1252 8.95861 6.84381 9.26008 6.84459 9.62406ZM7.52071 13.1286C7.16116 13.1444 6.86413 12.8604 6.84772 12.4964C6.84772 12.1324 7.12833 11.8317 7.48788 11.8151C7.83961 11.8143 8.1296 12.0912 8.13742 12.4465C8.15383 12.8113 7.87244 13.112 7.52071 13.1286ZM3.62426 9.65176C3.63989 10.0157 3.93769 10.3006 4.29725 10.284C4.64898 10.2682 4.92959 9.96668 4.91317 9.6027C4.90536 9.24663 4.61615 8.96968 4.26364 8.97048C3.90408 8.9863 3.62348 9.28778 3.62426 9.65176ZM4.30037 13.1326C3.94082 13.1492 3.6438 12.8643 3.62739 12.5003C3.6266 12.1363 3.90799 11.8349 4.26754 11.819C4.61928 11.8183 4.90927 12.0952 4.91708 12.4513C4.9335 12.8153 4.65289 13.1167 4.30037 13.1326Z"
                fill="#7D7D7D"
              />
            </svg>
          </div>
          <div>
            <span>Meeting Calender</span>
          </div>
        </NavLink>
      ),
    },

    {
      access: ["AD", "AR", "CO"],
      component: (
        <NavLink
          to="Documents"
          onClick={() => {
            dispatch(setActiveScreen("Documents"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "Documents" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.826 8.72L7.59375 5.43359V8.50906C7.59375 8.56501 7.61597 8.61866 7.65553 8.65822C7.69509 8.69778 7.74874 8.72 7.80469 8.72H10.826Z"
                fill="#7D7D7D"
              />
              <path
                d="M6.46875 9.42313V5.06375H2.10937C1.99749 5.06375 1.89018 5.1082 1.81106 5.18731C1.73195 5.26643 1.6875 5.37374 1.6875 5.48562V17.0169C1.6875 17.1288 1.73195 17.2361 1.81106 17.3152C1.89018 17.3943 1.99749 17.4388 2.10937 17.4388H10.8281C10.94 17.4388 11.0473 17.3943 11.1264 17.3152C11.2056 17.2361 11.25 17.1288 11.25 17.0169V9.845H6.89062C6.77874 9.845 6.67143 9.80055 6.59231 9.72144C6.5132 9.64232 6.46875 9.53501 6.46875 9.42313ZM12.8672 4.22H15.8885L12.6562 0.933594V4.00906C12.6562 4.06501 12.6785 4.11866 12.718 4.15822C12.7576 4.19778 12.8112 4.22 12.8672 4.22Z"
                fill="#7D7D7D"
              />
              <path
                d="M11.9531 5.34375C11.8412 5.34375 11.7339 5.2993 11.6548 5.22019C11.5757 5.14107 11.5312 5.03376 11.5312 4.92188V0.5625H6.04688C5.93499 0.5625 5.82768 0.606947 5.74856 0.686064C5.66945 0.765181 5.625 0.872487 5.625 0.984375V3.9375H7.10578C7.29479 3.93826 7.48178 3.97635 7.65602 4.04959C7.83026 4.12284 7.98831 4.22979 8.12109 4.3643L11.9588 8.26664C12.2265 8.53829 12.376 8.90476 12.3746 9.28617V14.0625H15.8906C16.0025 14.0625 16.1098 14.0181 16.1889 13.9389C16.2681 13.8598 16.3125 13.7525 16.3125 13.6406V5.34375H11.9531Z"
                fill="#7D7D7D"
              />
            </svg>
          </div>
          <div>
            <span>Documents</span>
          </div>
        </NavLink>
      ),
    },
    {
      access: ["AD", "AR", "CO"],
      component: (
        <NavLink
          to="Task"
          onClick={() => {
            dispatch(setActiveScreen("Task"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "Task" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_293_5736"
                // style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
              >
                <rect width="18" height="18" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_293_5736)">
                <path
                  d="M8.2125 13.5L12.45 9.2625L11.3625 8.175L8.19375 11.3438L6.61875 9.76875L5.55 10.8375L8.2125 13.5ZM4.5 16.5C4.0875 16.5 3.73438 16.3531 3.44063 16.0594C3.14688 15.7656 3 15.4125 3 15V3C3 2.5875 3.14688 2.23438 3.44063 1.94063C3.73438 1.64688 4.0875 1.5 4.5 1.5H10.5L15 6V15C15 15.4125 14.8531 15.7656 14.5594 16.0594C14.2656 16.3531 13.9125 16.5 13.5 16.5H4.5ZM9.75 6.75H13.5L9.75 3V6.75Z"
                  fill="#7D7D7D"
                />
              </g>
            </svg>
          </div>
          <div>
            <span>Task</span>
          </div>
        </NavLink>
      ),
    },
    {
      access: ["AD"],
      component: (
        <NavLink
          to="ManageUsers"
          onClick={() => {
            dispatch(setActiveScreen("ManageUsers"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "ManageUsers" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.12499 8.41526C8.19092 8.41526 9.84696 6.73779 9.84696 4.64513C9.84696 2.55247 8.19092 0.875 6.12499 0.875C4.05906 0.875 2.40302 2.55247 2.40302 4.64513C2.40302 6.73779 4.05906 8.41526 6.12499 8.41526ZM6.125 10.2617C3.09067 10.2617 0.5 10.7469 0.5 12.6852C0.5 14.6227 3.0749 15.1253 6.125 15.1253C9.15858 15.1253 11.75 14.6402 11.75 12.7019C11.75 10.7636 9.1751 10.2617 6.125 10.2617ZM13.9235 6.1909H14.8258C15.1972 6.1909 15.5 6.49798 15.5 6.87461C15.5 7.25124 15.1972 7.55832 14.8258 7.55832H13.9235V8.44129C13.9235 8.81792 13.6214 9.125 13.2492 9.125C12.8778 9.125 12.575 8.81792 12.575 8.44129V7.55832H11.6742C11.3021 7.55832 11 7.25124 11 6.87461C11 6.49798 11.3021 6.1909 11.6742 6.1909H12.575V5.30871C12.575 4.93208 12.8778 4.625 13.2492 4.625C13.6214 4.625 13.9235 4.93208 13.9235 5.30871V6.1909Z"
                fill="#7D7D7D"
              />
            </svg>
          </div>
          <div>
            <span>Manage Users</span>
          </div>
        </NavLink>
      ),
    },
    {
      access: ["AD"],
      component: (
        <NavLink
          to="Configuration"
          onClick={() => {
            dispatch(setActiveScreen("Configuration"));
          }}
          className={`side_menu_dashboardbtn1 mt-3 ${
            panel === "Configuration" ? "make_side_menu_yellow" : ""
          }`}
          style={{ gap: "15px", width: "100%" }}
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3018 9.185C14.57 9.3275 14.777 9.5525 14.9226 9.7775C15.2062 10.2425 15.1832 10.8125 14.9073 11.315L14.3707 12.215C14.0871 12.695 13.5583 12.995 13.0141 12.995C12.7458 12.995 12.4469 12.92 12.2016 12.77C12.0024 12.6425 11.7724 12.5975 11.5271 12.5975C10.7683 12.5975 10.1322 13.22 10.1092 13.9625C10.1092 14.825 9.40403 15.5 8.52259 15.5H7.48019C6.59109 15.5 5.88594 14.825 5.88594 13.9625C5.87061 13.22 5.23444 12.5975 4.47564 12.5975C4.2227 12.5975 3.99276 12.6425 3.80115 12.77C3.55588 12.92 3.24929 12.995 2.98869 12.995C2.43683 12.995 1.90797 12.695 1.62438 12.215L1.09551 11.315C0.811922 10.8275 0.796592 10.2425 1.08019 9.7775C1.20282 9.5525 1.43276 9.3275 1.69336 9.185C1.90797 9.08 2.04594 8.9075 2.17623 8.705C2.55947 8.06 2.32953 7.2125 1.67803 6.83C0.919227 6.4025 0.673957 5.45 1.11084 4.7075L1.62438 3.8225C2.06893 3.08 3.01935 2.8175 3.78582 3.2525C4.45265 3.6125 5.31875 3.3725 5.70965 2.735C5.83229 2.525 5.90127 2.3 5.88594 2.075C5.87061 1.7825 5.95492 1.505 6.10055 1.28C6.38414 0.815 6.89768 0.515 7.4572 0.5H8.53792C9.10511 0.5 9.61864 0.815 9.90223 1.28C10.0402 1.505 10.1322 1.7825 10.1092 2.075C10.0939 2.3 10.1628 2.525 10.2855 2.735C10.6764 3.3725 11.5425 3.6125 12.217 3.2525C12.9758 2.8175 13.9339 3.08 14.3707 3.8225L14.8843 4.7075C15.3288 5.45 15.0836 6.4025 14.3171 6.83C13.6656 7.2125 13.4357 8.06 13.8266 8.705C13.9492 8.9075 14.0871 9.08 14.3018 9.185ZM5.83229 8.0075C5.83229 9.185 6.8057 10.1225 8.00906 10.1225C9.21241 10.1225 10.1628 9.185 10.1628 8.0075C10.1628 6.83 9.21241 5.885 8.00906 5.885C6.8057 5.885 5.83229 6.83 5.83229 8.0075Z"
                fill="#7D7D7D"
              />
            </svg>
          </div>
          <div>
            <span>Configuration</span>
          </div>
        </NavLink>
      ),
    },

    // ${
    //   panel === "Logout" ? "make_side_menu_yellow" : ""
    // }
    {
      access: ["AD", "AR", "CO"],
      component: (
        <NavLink
          to="#"
          onClick={() => {
            setOpenLogout(true);
          }}
          className={`side_menu_dashboardbtn1 make_side_menu_yellow_logout mt-3`}
          style={{ justifyContent: "start", textDecoration: "none" }}
        >
          <div
            className="flex items-center "
            style={{ gap: "15px", width: "100%" }}
            onClick={() => {
              // dispatch(setreffrelLIstingLeads("refleadlisting"));
            }}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.42151 7.4225C6.09339 7.4225 5.83394 7.6775 5.83394 8C5.83394 8.315 6.09339 8.5775 6.42151 8.5775H11V12.1625C11 14 9.48147 15.5 7.60429 15.5H3.88808C2.01853 15.5 0.5 14.0075 0.5 12.17V3.8375C0.5 1.9925 2.02616 0.5 3.89571 0.5H7.61955C9.48147 0.5 11 1.9925 11 3.83V7.4225H6.42151ZM13.7227 5.40513L15.9127 7.58763C16.0252 7.70013 16.0852 7.84263 16.0852 8.00013C16.0852 8.15013 16.0252 8.30013 15.9127 8.40513L13.7227 10.5876C13.6102 10.7001 13.4602 10.7601 13.3177 10.7601C13.1677 10.7601 13.0177 10.7001 12.9052 10.5876C12.6802 10.3626 12.6802 9.99513 12.9052 9.77013L14.1052 8.57763H11.0002V7.42263H14.1052L12.9052 6.23013C12.6802 6.00513 12.6802 5.63763 12.9052 5.41263C13.1302 5.18013 13.4977 5.18013 13.7227 5.40513Z"
                  fill="#7D7D7D"
                />
              </svg>
            </div>
            <div>
              <span className="text-[#909090]">Logout</span>
            </div>
          </div>
        </NavLink>
      ),
    },
  ];
  return (
    <>
      <div className="bg-[#FFFFFF] flex items-center">
        <div
          className="flex justify-start items-start mb-[15px]"
          style={{ width: "100%" }}
        >
          <div className=" flex  items-center  pt-3">
            <Avatar
              alt={localStorage.getItem("userName") || "-"}
              sx={{ width: 50, height: 50 }}
              className="me-2"
            />
            <div className="profile_details">
              <span>{localStorage.getItem("userName") || "-"}</span>
              <p
                className="cursor-pointer"
                onClick={() => {
                  navigate("/Home/Profile");
                }}
              >
                View Details
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        {arrayNavbar.map((value, index) => (
          <div key={index}>
            <RanderNavbar value={value} />
          </div>
        ))}
      </div>
      {/* logout modal  */}
      <Dialog
        open={openLogout}
        onClose={() => {
          setOpenLogout(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          zIndex: 30,
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              minWidth: "404px",
              height: "246px",
            },
          },
        }}
      >
        <div className="p-5">
          <div>
            <div className="flex justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="71"
                height="71"
                fill="none"
                viewBox="0 0 71 71"
              >
                <g>
                  <path
                    fill="#FE3E3E"
                    fillRule="evenodd"
                    d="M.918 35.497C.918 16.411 16.411.914 35.501.914c19.125 0 34.584 15.497 34.584 34.583 0 19.094-15.46 34.584-34.584 34.584C16.411 70.08.918 54.59.918 35.497zm31.54-13.107c0-1.656 1.383-3.043 3.043-3.043 1.66 0 3.01 1.387 3.01 3.043v15.286a3.009 3.009 0 01-3.01 3.009c-1.66 0-3.043-1.345-3.043-3.009V22.39zm3.078 29.296a3.048 3.048 0 01-3.043-3.044 3.01 3.01 0 013.008-3.008c1.695 0 3.044 1.349 3.044 3.008 0 1.66-1.35 3.044-3.01 3.044z"
                    clipRule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div className="mt-5">
              <p className="text-center font-[Gm] text-[18px] font-semibold text-[#0E0E0E]">
                Are you sure want to Logout?
              </p>
            </div>
          </div>
          <div className="flex justify-between items-center gap-[13px] mt-8">
            <div
              className="confirm_logout"
              onClick={() => {
                // sessionStorage.clear();
                localStorage.clear();
                // localStorage.removeItem("email");
                navigate("/");
                dispatch(clearClientState());
                dispatch(clearClientStatescreen());
                dispatch(clearClientStateuser());
                dispatch(clearClientStateDoc());
                // localStorage.clear();
                // persistor.purge();
                // reset();
              }}
            >
              Logout
            </div>
            <div
              onClick={() => {
                setOpenLogout(false);
              }}
              className="cancel_logout"
            >
              Cancel
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default AdminSideBar;

const RanderNavbar = ({ value }: any) => {
  return (
    <>
      {value.access.includes(sessionStorage.getItem("UserType")) &&
        value.component}
    </>
  );
};
